import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/CreditCardExp';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得信用卡效期延長資訊
export function getInfoCreditCardExp() {
    return get(`${url}/info`);
}

// 送出信用卡效期延長申請內容
export function submitCreditCardExp(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
